import { useExtractionStore } from "@/stores/extraction-store"
import { useReconciliationStore } from "@/stores/reconciliation-store"
import type { CategoryState, ExtractionCategory } from "@/types/extraction"

function countUnseen(categories: Record<ExtractionCategory, CategoryState>): number {
  let count = 0
  for (const cat of Object.values(categories)) {
    if (cat.hasUnseenCompletion) count++
  }
  return count
}

/**
 * Qualify's "needs attention" count: analyses finished but not yet opened,
 * plus addendum changes waiting for a decision. Moved from the old Analysis
 * tab badge unchanged.
 */
export function useQualifyAttentionCount(bidId: string): number {
  const unseen = useExtractionStore((s) => countUnseen(s.categories))
  const pending = useReconciliationStore((s) =>
    // Only runs actively awaiting review count. Failed or still-in-flight runs
    // can strand pending proposals that will never be decided — counting
    // those would inflate the badge permanently.
    (s.runsByBid[bidId] ?? []).reduce(
      (sum, r) => (r.status === "review" ? sum + r.decisionCounts.pending : sum),
      0
    )
  )
  return unseen + pending
}
